module.exports = __webpack_public_path__ + "img/content-save-check-outline.d0b4980f.svg";